import { render } from "./SliderImages.vue?vue&type=template&id=2ce4cf98&scoped=true"
import script from "./SliderImages.vue?vue&type=script&lang=js"
export * from "./SliderImages.vue?vue&type=script&lang=js"

import "./SliderImages.vue?vue&type=style&index=0&id=2ce4cf98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce4cf98"]])

export default __exports__